<script>
// 静态提示区显示类型
const TIP_TYPE_MAP = {
  1: 'text',
  2: 'warning',
  3: 'warningBackGround',
  4: 'error',
  5: 'errorBackGround'
}

export default {
  name: 'tip-render',
  props: {
    node: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      TIP_TYPE_MAP,
      visible: true
    }
  },
  methods: {
    titleRender () {
      const name = <read-text line={1} value={this.node.name}/>
      return (
        this.node.name
          ? name
          : <SyEditShow
            value={this.node.content}
            class="design-static-area-title-none"
          />
      )
    },
    longTextRender () {
      const longText = <SyEditShow value={this.node.content}/>
      return this.node.name
        ? longText
        : null
    }
  },
  render () {
    const createElement = this.$createElement
    const {node, visible} = this
    const {default: defaultSlot, content, title} = node?.slots || {}
    return (
      <div class="static-area-wrap">
        {
          defaultSlot
            ? defaultSlot(createElement)
            : <tip
              visible={visible}
              on={{
                'update:visible': val => this.visible = val
              }}
              type={node.type ? TIP_TYPE_MAP[node.type] : 'warning'}
              hasClose={node.closed}
              scopedSlots={{
                title: title || this.titleRender,
                longText: content || this.longTextRender
              }}
            />
        }
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
.static-area-wrap {
  position: relative;
  margin-bottom: 12px;

  ::v-deep {
    a {
      text-decoration: none !important;
    }

    .sy-editor-show {
      .ql-editor {
        padding: 0;
      }
    }
  }
}
</style>